export default __webpack_public_path__ + "static/media/medall.866ae5fb.svg";